module.exports = __webpack_public_path__ + "img/t2.75530917.png";